<div
  class="load-bar"
  [ngStyle]="{ visibility: loading ? 'visible' : 'hidden' }"
>
  <div class="bar"></div>
  <div class="bar"></div>
  <div class="bar"></div>
</div>
<div #mapViewNode class="esri-view"></div>
